module.exports = __webpack_public_path__ + "img/抖音.0356d215.png";